import { render, staticRenderFns } from "./PicList.vue?vue&type=template&id=ef6ef07a&scoped=true"
import script from "./PicList.vue?vue&type=script&lang=js"
export * from "./PicList.vue?vue&type=script&lang=js"
import style0 from "./PicList.vue?vue&type=style&index=0&id=ef6ef07a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6ef07a",
  null
  
)

export default component.exports